<template>
  <full-width>
    <modal
      :displayModal="displayVerify"
      :displayShade="displayVerify"
      @hide-all="displayVerify = false"
      @show-modal="displayVerify = true"
      :rerouteOnClose="true"
    >
      <div>
        <div class="text-center">
          <div class="flex items-center justify-center">
            <img src="@/assets/img/mobile-login-logo.png" class="mr-5 h-14" />
            <h2
              class="items-center justify-center text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
            >
              View My Receipt
            </h2>
          </div>
          <p
            class="max-w-2xl mx-auto mt-2 text-base leading-7 text-center tmsk-blue-text"
          >
            Enter the
            <span class="font-bold"
              >Singapore registered mobile number used for purchase</span
            >
            <!-- <br v-if="activeBreakpoint !== 'sm'" /> -->
            to view your
            <!-- <br v-if="activeBreakpoint === 'sm'" /> -->
            <span class="font-bold">order details.</span>
          </p>

          <mobile-number-input
            class="my-4"
            @handleValid="(boolean) => (isMobileNumberValid = boolean)"
            @handleInput="(string) => (phone = string)"
            @handle-enter="handleSubmission"
          />
          <button
            type="button"
            :style="!isMobileNumberValid && 'box-shadow: none !important;'"
            :class="!isMobileNumberValid && 'opacity-50 cursor-not-allowed'"
            class="inline-flex justify-center w-full px-4 py-2 mt-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="handleSubmission"
          >
            Proceed
          </button>
        </div>
      </div>
    </modal>
    <div v-if="hasInit && txn !== null">
      <h2
        class="flex items-center justify-center mt-4 text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
      >
        {{ title }}
      </h2>
      <div
        class="flex flex-col items-center justify-center w-full max-w-lg px-1 py-4 mx-auto mt-8 space-y-6 md:px-0"
      >
        <!-- Order Instance -->
        <div class="w-full mx-1 tmsk-blue-border">
          <!-- Heading: Receipt # and tooltip -->
          <div class="flex justify-between px-4 py-2 text-white tmsk-blue-bg">
            <h1 class="font-bold">
              {{ title }}:
              {{ txn.uuid.split("-")[0] }}
            </h1>
            <tooltip color="white" height="h-auto" class="float-right">
              <p>
                For more information on order refund or exchange, please visit
                the
                <a
                  target="_blank"
                  href="https://stayprepared.sg/masks-faq"
                  class="font-bold text-red-600 underline"
                  >FAQ</a
                >
                section.
              </p>
            </tooltip>
          </div>
          <!-- Items -->
          <div v-for="item in transaction.items" :key="item.sku">
            <div class="border-2 border-t-0 first:border-t-2 tmsk-blue-border">
              <!-- Items -->
              <div class="p-4 tmsk-blue-text tmsk-blue-border">
                <div class="mb-4 md:flex">
                  <!-- Details -->
                  <div
                    class="items-center justify-center block md:justify-start"
                  >
                    <img
                      :src="require(`@/assets/img/${item.sku}.png`)"
                      :alt="item.name"
                      class="w-1/2 mx-auto md:w-4/5 md:ml-0 ie11-small-img"
                    />
                    <h2
                      class="w-full mx-auto my-4 text-xl font-bold text-center md:w-4/5 tmsk-blue-text md:mt-4 md:ml-0"
                    >
                      {{ item.name }}
                    </h2>
                  </div>
                  <!-- QR Code -->
                  <div class="relative w-full h-full">
                    <template
                      v-if="
                        (item.qtyUncollected === 0 &&
                          ['success', 'exchanged'].includes(txn.status)) ||
                        ['refunded'].includes(txn.status)
                      "
                    >
                      <div
                        class="absolute z-20 w-full h-full bg-white"
                        style="opacity: 0.9"
                      />
                      <p
                        class="absolute z-30 flex items-center justify-center w-full h-full text-2xl font-extrabold text-red-600"
                      >
                        <template
                          v-if="
                            item.qtyUncollected === 0 &&
                            ['success', 'exchanged'].includes(txn.status)
                          "
                        >
                          COLLECTED
                        </template>
                        <template v-else-if="['refunded'].includes(txn.status)">
                          REFUNDED
                        </template>
                      </p>
                    </template>
                    <div
                      class="flex items-center justify-center w-56 h-56 mx-auto sm:w-64 sm:h-64"
                    >
                      <canvas
                        class="absolute w-56 h-56 mx-auto sm:w-64 sm:h-64 canvas"
                      />
                      <qr-code
                        class="z-10 w-48 h-48 sm:w-56 sm:h-56"
                        level="Q"
                        :value="
                          (item.qtyUncollected === 0 &&
                            ['success', 'exchanged'].includes(txn.status)) ||
                          txn.status === 'refunded'
                            ? ''
                            : item.qr
                        "
                        renderAs="canvas"
                        :size="activeBreakpoint === 'sm' ? 192 : 224"
                      />
                    </div>
                  </div>
                </div>
                <p>
                  <span class="font-bold">Price:</span>
                  {{
                    txn.status === "exchanged"
                      ? "Not For Sale"
                      : `$${item.price.toFixed(2)} / pack`
                  }}
                </p>
                <p>
                  <span class="font-bold">Collected:</span>
                  {{ item.qtyTotal - item.qtyUncollected }} /
                  {{ item.qtyTotal }}
                </p>
                <p>
                  <span class="font-bold">Amount:</span>
                  {{
                    txn.status === "exchanged"
                      ? "Not For Sale"
                      : `$${(item.qtyTotal * item.price).toFixed(2)}`
                  }}
                </p>
                <p
                  v-if="
                    (txn.status === 'success' && !isCollected) ||
                    txn.status === 'exchanged'
                  "
                  class="mt-6 text-red-700"
                >
                  No partial refund is allowed on this order.
                </p>
                <p
                  v-if="limitedLocationsSkuId === item.sku"
                  class="mt-2 text-red-700"
                  data-e2e-attr="deeplink-qrcode-collection"
                >Scan QR code to collect your mask at <span
                    data-e2e-attr="deeplink-sku-available-location-text"
                    class="font-bold underline cursor-pointer"
                    @click="routeToLocateVM(item.sku)"
                  >Community Centres/Clubs, Plaza Singapura or Temasek Shophouse only.
                  </span>
                </p>
                <p v-else class="mt-2 text-red-700"
                   data-e2e-attr="deeplink-qrcode-collection">
                  Scan QR code to collect your mask from <span
                    data-e2e-attr="deeplink-sku-available-location-text"
                    class="font-bold underline cursor-pointer"
                    @click="routeToLocateVM(item.sku)"
                  >over 800 locations island-wide.
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="flex justify-center px-4 py-2 text-white tmsk-blue-bg">
            <h1 class="font-bold">Total: ${{ totalAmount.toFixed(2) }}</h1>
          </div>
        </div>
      </div>
      <modal
        :displayModal="displayModal"
        :displayShade="displayModal"
        @hide-all="displayModal = false"
        @show-modal="displayModal = true"
      >
        <div v-if="modalData != null" class="pb-10 tmsk-blue-text">
          <div class="flex justify-end pb-3 mr-1">
            <button @click="displayModal = false">
              <svg viewBox="0 0 20 20" fill="#bbb" class="w-6 h-6 x">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          <div class="flex items-center justify-center">
            <img
              :src="require(`@/assets/img/${modalData.sku}.png`)"
              :alt="modalData.sku"
              class="w-1/4"
            />
            <h1 class="ml-2 text-lg font-bold">{{ modalData.name }}</h1>
          </div>
          <div class="relative mx-auto">
            <p
              v-if="
                modalData.qtyUncollected === 0 &&
                ['success', 'exchanged'].includes(modalData.txnStatus)
              "
              class="absolute z-20 flex items-center justify-center w-full h-full text-2xl font-bold text-red-600 bg-white opacity-75"
            >
              COLLECTED
            </p>
            <p
              v-else-if="['refunded'].includes(modalData.txnStatus)"
              class="absolute z-20 flex items-center justify-center w-full h-full text-2xl font-bold text-red-600 bg-white opacity-75"
            >
              REFUNDED
            </p>
            <div
              class="flex items-center justify-center w-56 h-56 mx-auto sm:w-64 sm:h-64"
            >
              <canvas
                class="absolute w-56 h-56 mx-auto sm:w-64 sm:h-64 canvas"
              />
              <qr-code
                class="z-10 w-48 h-48 sm:w-56 sm:h-56"
                level="Q"
                :value="
                  (modalData.qtyUncollected === 0 &&
                    ['success', 'exchanged'].includes(modalData.txnStatus)) ||
                  modalData.txnStatus === 'refunded'
                    ? ''
                    : modalData.qr
                "
                renderAs="canvas"
                :size="activeBreakpoint === 'sm' ? 192 : 224"
              />
            </div>
          </div>
        </div>
      </modal>
    </div>
  </full-width>
</template>

<script>
import QrCode from 'qrcode.vue'
import 'swiper/css/swiper.css'
import { mapGetters, mapState } from 'vuex'

import beepAPI from '../../mixins/beepAPI'
import FullWidth from '../../components/Layout/FullWidth'
import MobileNumberInput from '../../components/MobileNumberInput'
import Tooltip from '../../components/Tooltip'
import Modal from '../../components/Modal'
export default {
  name: 'DeepLinkReceipt',
  metaInfo () {
    return {
      title: 'Receipt',
      // meta: [
      //   { property: 'og:title', content: 'StayMasked' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'StayMasked' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    Modal,
    Tooltip,
    QrCode,
    FullWidth,
    MobileNumberInput
  },
  mixins: [beepAPI],
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      hasInit: false,
      txn: null,
      displayModal: false,
      modalData: null,
      displayVerify: false,
      phone: '',
      isMobileNumberValid: false,
      skuSortOrder: [
        'SM6_MASK_M',
        'SM6_MASK_L',
      ],
      limitedLocationsSkuId: ''
    }
  },
  computed: {
    ...mapState(['mobileNumbers']),
    ...mapGetters(['activeBreakpoint']),
    title () {
      if (this.txn.status === 'exchanged') return 'Exchange'
      else if (this.txn.status === 'refunded') return 'Refund'
      return 'Receipt'
    },

    totalAmount () {
      // let total = 0
      // this.txn.items.forEach(({ price }) => {
      //   total += price
      // })

      // return total
      return this.txn.amount
    },

    transaction () {
      const transaction = this.txn
      const sortedItems = []
      this.skuSortOrder.forEach((sku) => {
        const item = transaction.items.find(item => item.sku === sku)
        if (item) sortedItems.push(item)
      })

      transaction.items = sortedItems
      return transaction
    }
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {
  },
  mounted () {
    // check if mobilenumber exists
    // dont show modal and proceed
    const mobile = this.mobileNumbers.accountNumber
    if (mobile !== '') {
      this.phone = mobile
      this.setIsLoading(true)
      this.loadPage()
    } else {
      this.displayVerify = true
    }
    // else if ''
    // show modal
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    handleFetchReceipt () {
      return new Promise((resolve, reject) => {
        this.getReceipt(this.uuid, this.phone).then(
          response => {
            this.txn = response
            setTimeout(this.paintCanvas, 50)
            resolve()
          },
          error => {
            this.createModal({
              title: 'Something went wrong',
              message: 'You have entered an incorrect mobile number. Please login to the account used for purchase to retrieve your order history.',
              btnMessage: 'Proceed',
              callback: () => { this.$router.push({ name: 'Login' }) }
            })
            reject(error)
          }
        )
      })
    },

    handleSubmission () {
      this.displayVerify = false
      this.setIsLoading(true)
      this.loadPage()
    },

    loadPage () {
      this.handleFetchReceipt()
        .then(
          () => {
            this.hasInit = true
            this.setIsLoading(false)
          },
          () => {
            this.setIsLoading(false)
          }
        )
    },

    isCollected () {
      // qtyUncollected > 0 = pending collection
      const uncollectedItem = this.txn.items.find(item => item.qtyUncollected > 0)
      if (uncollectedItem === undefined) return true
      else return false
    },

    redeem (txnStatus, item) {
      this.displayModal = true
      this.modalData = { txnStatus, ...item }
    },

    routeToLocateVM (sku) {
      this.$router.push({ path: `/locate-vending-machines/${sku}` })
    },

    paintCanvas () {
      var collection = document.querySelectorAll('.canvas')
      for (let i = 0; i < collection.length; i++) {
        const canvas = collection[i]
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
      }
    }
  }
}
</script>

<style scoped>
</style>
